import { compareSliceActions } from "./compareSlice"

export const compareActions = {
    ...compareSliceActions,
}
